import { getSellerPath } from "@/lib/routing/portal-urls";

function decodeSlug(value: string): string {
  try {
    return decodeURIComponent(value);
  } catch {
    return value;
  }
}

export function resolvePublicSellerRedirectPath(
  locale: string,
  redirectPath: string,
): string {
  const fallbackPath = `/${locale}/login`;
  const normalizedPath = redirectPath.trim();

  if (!normalizedPath) {
    return fallbackPath;
  }

  const sellerMatch = normalizedPath.match(/^\/seller\/([^/]+)$/);
  if (sellerMatch) {
    return getSellerPath(locale, decodeSlug(sellerMatch[1]));
  }

  return fallbackPath;
}
